module.exports = __webpack_public_path__ + "img/banner-central.b6beb42a.jpg";